var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheHeader'),_c('div',{attrs:{"id":"main"}},[_c('TheSidebar'),_c('transition',{attrs:{"name":"route","mode":"out-in"}},[_c('router-view',{attrs:{"id":"content"}})],1)],1),_c('Modal'),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }